import classNames from 'classnames';
import { memo, useMemo } from 'react';
import Icon from '../../icons';
import { CustomInputProps } from '../../interfaces';
import '../../styles.scss';
import { createNewWidthHeightStyle } from '../../utils';
import { CustomPasswordInputWrapper } from './styles';
import './styles.scss';

const CustomInput: React.FC<CustomInputProps> = props => {
  const { width, height, className, style = {}, onChange, ...rest } = props;

  const newStyle = useMemo(() => {
    return { ...style, ...createNewWidthHeightStyle({ width, height }) };
  }, [width, height, style]);

  const newClassName = classNames(className, 'custom-input');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(
      className?.includes('controlledInput') ? (e.target.value as any) : e,
    );
  };

  return (
    <CustomPasswordInputWrapper
      {...rest}
      className={newClassName}
      style={newStyle}
      onChange={handleChange}
      iconRender={visible =>
        visible ? (
          <Icon name="eyeOpen" color="var(--primary)" cursor="pointer" />
        ) : (
          <Icon name="eyeClose" color="var(--primary)" cursor="pointer" />
        )
      }
    />
  );
};

export default memo(CustomInput);
